export default __webpack_public_path__ + "static/media/ZOOM.6a62cb1f.png";